import useDebouncedState from '@aytm/lib/hooks/useDebouncedState'
import usePropChangeEffect from '@aytm/lib/hooks/usePropChangeEffect'
import { InputTextarea as PrimeInputTextArea } from 'primereact/inputtextarea'

import React, { useState, KeyboardEventHandler } from 'react'

interface InputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  debounce: number
  value: string
  onInputChange: (value: string) => void
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  onKeyPress?: KeyboardEventHandler<HTMLTextAreaElement>
  style?: object
  autoResize: boolean
}

export default function InputTextarea({
  debounce,
  value,
  style,
  autoResize,
  onInputChange,
  onChange,
  onKeyPress,
  ...rest
}: InputProps) {
  const [inputValue, setInputValue] = useState<string>(value)
  const [debouncedInputValue, setDebouncedInputValue] = useDebouncedState<string>(debounce, value)

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    void (null != onChange && onChange(event))
    setInputValue(event.target.value)
    setDebouncedInputValue(event.target.value)
  }

  usePropChangeEffect<string>(value, current => {
    void (inputValue !== current && setInputValue(current))
    void (debouncedInputValue !== current && setDebouncedInputValue(current))
  })

  usePropChangeEffect<string>(
    debouncedInputValue,
    current => void (null != onInputChange && value !== current && onInputChange(current))
  )

  return (
    <PrimeInputTextArea
      value={inputValue}
      onChange={handleInputChange}
      style={style}
      autoResize={autoResize}
      onKeyPress={onKeyPress || null}
      {...rest}
    />
  )
}
